// Package Imports
import { toJS } from "mobx";

// Project Imports
import OptimizationStore from "../../store/OptimizationStore";
import AuthStore from "../../../login/store/AuthStore";
import { EMPLOYER_EMPLOYEE_SCHEME_B, MWP_ACT } from 'constants/ CustomerType';

const generateChangeProposerDataStructure = (data, selectedNeedData) => {
  let productListData = toJS(OptimizationStore.product_list_data);
  const journeyData = toJS(AuthStore.journeyData);
  let { family_details_list, journey_details } = journeyData;

  let prDetails = family_details_list.find(
    (familyData) => familyData.id === data.proposer_id
  );
  let riskList = [];
  let productWiseRiskList = [];

  if (journey_details.high_risk_selected) riskList.push("high");
  riskList = [...riskList, ...["medium", "low"]];
  riskList.forEach((item) => {
    productWiseRiskList.push({
      risk: item,
      BI: {},
      bi_request: {},
      update_BI: false,
    });
  });
  let setLaDetails = AuthStore.journeyTypeName === EMPLOYER_EMPLOYEE_SCHEME_B || AuthStore.journeyTypeName === MWP_ACT
  productListData.map((item) => {
    item.data.forEach((value) => {
      if (!Array.isArray(value.BI)) {
        // For single products
        if (
          item.need_unique_name === selectedNeedData.unique_name &&
          value.family_product_id === data.family_product_id
        ) {
          if(setLaDetails) value.life_assured_details = prDetails;
          value.proposer_details = prDetails;
          value.BI = { risk: "high", BI: {}, bi_request: {}, update_BI: false };
          value.changeProductList = value.changeProductList || [];
          value.fieldChanged = false;
          value.update_BI = false;
        }
      } else {
        // For multiple products to show in a tab
        value.BI.forEach((productDetails) => {
          if (
            item.need_unique_name === selectedNeedData.unique_name &&
            value.family_product_id === data.family_product_id
          ) {
          if(setLaDetails) value.life_assured_details = prDetails;
            value.proposer_details = prDetails;
            value.BI = productWiseRiskList;
            productDetails.changeProductList =
              productDetails.changeProductList || [];
            productDetails.fieldChanged = false;
            productDetails.update_BI = false;
          }
        });
      }
    });
    return item;
  });
  OptimizationStore.product_list_data = [...productListData];
};

export default generateChangeProposerDataStructure;
